import {
  getUsers,
  getRoles,
  assignRole,
  reassignRole,
  assignPermissions,
  removeRole,
  removeAllRoles,
  getUserApps,
  createUserApp,
  deleteUserApps,
} from "@/api/permissions";
import Vue from "vue";

const state = {
  users: [],
  roles: [],
  userApps: [],
};

const mutations = {
  SET_USERS(state, users) {
    state.users = users;
  },
  SET_ROLES(state, roles) {
    state.roles = roles;
  },
  SET_USER_APPS(state, userApps) {
    state.userApps = userApps;
  },
  UPDATE_USER_ROLES(state, { userId, roles }) {
    const user = state.users.find((u) => u.id === userId);
    if (user) Vue.set(user, "roles", roles);
  },
};

const actions = {
  async fetchUsers({ commit }) {
    try {
      const users = await getUsers();
      commit("SET_USERS", users);
    } catch (e) {
      Vue.$toast.error(e, { duration: 0 });
    }
  },
  async fetchRoles({ commit }) {
    try {
      const roles = await getRoles();
      commit("SET_ROLES", roles);
    } catch (e) {
      Vue.$toast.error(e, { duration: 0 });
    }
  },
  async fetchUserApps({ commit }) {
    try {
      const userApps = await getUserApps();
      commit("SET_USER_APPS", userApps);
    } catch (e) {
      Vue.$toast.error(e, { duration: 0 });
    }
  },
  async addUserRole({ commit, state }, { userId, roleName }) {
    await assignRole({ user_id: userId, role_name: roleName });
    const user = state.users.find((u) => u.id === userId);
    const currentRoles = user?.roles || [];
    if (!currentRoles.includes(roleName)) {
      commit("UPDATE_USER_ROLES", {
        userId,
        roles: [...currentRoles, roleName],
      });
    }
  },
  async assignRole({ commit }, { userId, roleName }) {
    await reassignRole(userId, { role_name: roleName });
    commit("UPDATE_USER_ROLES", {
      userId,
      roles: [roleName],
    });
  },
  async removeRole({ commit, state }, { userId, roleName }) {
    await removeRole(userId, { role_name: roleName });
    const user = state.users.find((u) => u.id === userId);
    const currentRoles = user?.roles || [];
    commit("UPDATE_USER_ROLES", {
      userId,
      roles: currentRoles.filter((r) => r !== roleName),
    });
  },
  async removeAllRoles({ commit }, userId) {
    await removeAllRoles(userId);
    commit("UPDATE_USER_ROLES", { userId, roles: [] });
  },
  // Assign a role and a set of apps to a user in a single request.
  async assignPermissions(
    { commit, dispatch },
    { userId, roleName, appIds, replaceRoles = true }
  ) {
    await assignPermissions({
      user_id: userId,
      role_name: roleName,
      app_ids: appIds,
      replace_roles: replaceRoles,
    });
    commit("UPDATE_USER_ROLES", { userId, roles: [roleName] });
    await dispatch("fetchUserApps");
  },
  async createUserApp({ dispatch }, { email, appId }) {
    await createUserApp({ email, app_id: appId });
    await dispatch("fetchUserApps");
  },
  async deleteUserApps({ dispatch }, { email, appIds }) {
    await deleteUserApps({ email, app_ids: appIds });
    await dispatch("fetchUserApps");
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
